// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__Mhs08","ranges":"BmiRanges_ranges__1mLRm"};